var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-area__inner no-padding no-scroll-y"},[_c('ContentAreaTitle',{ref:"titleBar",attrs:{"title":_vm.$store.getters.client.name,"subtitle":_vm.$store.getters.client.description ? _vm.$store.getters.client.description : 'N/A',"tabs":_vm.$router.options.routes[1].children[1].children}}),_vm._v(" "),_c('router-view',{key:"client",style:({
        'position': 'absolute',
        'height': 'auto',
        'margin-top': ((this.titleBarHeight) + "px"),
        'top': 0,
        'right': 0,
        'bottom': 0,
        'left': 0
    })})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aba3094","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/Client.vue
// module id = null
// module chunks = 